import {
	ChangeDetectionStrategy,
	Component,
	computed,
	inject,
	signal,
} from '@angular/core';
import { fade } from '@core/animations/animations';
import { ICON } from '@core/util/icon';
import { select } from '@ngxs/store';
import { MatterNotesState } from '@state/matter/notes';
import { ModalService } from '@ui/modal/modal.service';
import { CreateNoteComponent } from '../create-note/create-note.component';
import { TestHooks } from './home.hooks';

@Component({
	selector: 'app-home',
	templateUrl: './home.component.html',
	styleUrls: ['./home.component.scss'],
	animations: [fade()],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class SaleHomeComponent {
	testHooks = TestHooks;
	public modalService = inject(ModalService);

	public ICON = ICON;
	public readonly SHOW_NOTES_COUNT = 3;

	notes_ = select(MatterNotesState.getAll);

	showAllNotes_ = signal(false);
	notesToDisplay_ = computed(() =>
		this.showAllNotes_()
			? this.notes_()
			: this.notes_().slice(0, this.SHOW_NOTES_COUNT),
	);

	toggleShowAllNotes(): void {
		this.showAllNotes_.set(!this.showAllNotes_());
	}

	createNote(): void {
		this.modalService.openModal(CreateNoteComponent, {
			title: 'Create note',
		});
	}
}
